// biome-ignore-all lint/a11y: TODO - address a11y issues later
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InfoTooltip } from "@/components/ui/info-tooltip";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BenchmarkToggleProps {
  showBenchmarks: boolean;
  setShowBenchmarks: (show: boolean) => void;
  onConfigureClick: () => void;
  hasBenchmarkConfig: boolean;
}

export function BenchmarkToggle({
  showBenchmarks,
  setShowBenchmarks,
  onConfigureClick,
  hasBenchmarkConfig,
}: BenchmarkToggleProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Segmented control: main toggle area + settings segment when enabled */}
      <div className="inline-flex h-8">
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-8 rounded-r-none hover:bg-background hover:text-foreground hover:border-border"
        >
          <div className="inline-flex items-center gap-2 px-3 h-8 text-sm">
            <div className="flex items-center gap-1">
              <span className="text-xs font-medium">Show Benchmarks</span>
              <InfoTooltip
                trigger={
                  <button
                    className="text-muted-foreground transition-colors"
                    aria-label="Benchmark information"
                  >
                    <InfoCircledIcon className="h-4 w-4" />
                  </button>
                }
                side="bottom"
                className="w-[280px]"
              >
                <div className="text-sm">
                  <h4 className="font-medium mb-1">Campaign Benchmarks</h4>
                  <p className="text-muted-foreground">
                    Compare this campaign's performance with similar campaigns
                    to see how it measures up against benchmarks.
                  </p>
                </div>
              </InfoTooltip>
            </div>
            <Switch
              checked={showBenchmarks}
              onCheckedChange={setShowBenchmarks}
              aria-label="Toggle benchmark comparison"
              className="ml-1 data-[state=checked]:bg-primary"
            />
          </div>
        </Button>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 rounded-l-none border-l-0 hover:bg-background hover:text-foreground hover:border-border"
              onClick={onConfigureClick}
              aria-label={
                hasBenchmarkConfig
                  ? "Reconfigure benchmark cohort"
                  : "Configure benchmark cohort"
              }
            >
              <Settings className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            {hasBenchmarkConfig
              ? "Reconfigure benchmark cohort"
              : "Configure benchmark cohort"}
          </TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
}
